const header = document.querySelector('.site-header');
const hamburger = document.querySelector('.hamburger');
const mobileNav = document.querySelector('.mobile-nav-wrapper');
const parentMenuItem = mobileNav.querySelector('.menu-item--has-children a');
let isSubMenuOpen = false;

const toggleNav = () => {
  header.classList.toggle('is-nav-open');
  mobileNav.classList.toggle('is-open');
  hamburger.classList.toggle('is-open');
  document.body.classList.toggle('overflow-hidden');
};

hamburger.addEventListener('click', toggleNav);

parentMenuItem?.addEventListener('click', function (e) {
  const subMenuHeight =
    mobileNav.querySelector('.sub-menu__inner').offsetHeight;
  const subMenu = mobileNav.querySelector('.sub-menu');
  isSubMenuOpen = !isSubMenuOpen;
  e.preventDefault();
  parentMenuItem.classList.toggle('is-open');

  if (isSubMenuOpen) {
    subMenu.style.maxHeight = subMenuHeight + 'px';
  } else {
    subMenu.style.maxHeight = 0 + 'px';
  }
});
